export const USER_MENTION_PREFIX = "@";
export const USER_MENTION_REGEX_STR = `(${USER_MENTION_PREFIX}(?<username>[^Q\\s]+@\\S+))`;

export const TEAM_MENTION_PREFIX = "@team:";
export const TEAM_MENTION_REGEX_STR = `${TEAM_MENTION_PREFIX}(?<team>\\d+)`;
